export async function createBatchKeys({ socket, token, serverId, groupName, count }) {
  if (!token) throw new Error("登录已失效，请重新登录");
  if (String(serverId) !== "1") throw new Error("批量新增仅支持当前配置的虚拟服务器 1");
  if (!groupName || typeof groupName !== "string") throw new Error("请选择服务器身份组");
  if (!Number.isInteger(count) || count < 1 || count > 100) throw new Error("数量须为 1～100 的整数");

  // Reuse Manager's existing session recovery; never persist or log these credentials.
  const credentials = await new Promise((resolve, reject) => {
    const timer = setTimeout(() => reject(new Error("读取登录会话超时，请重新登录")), 10000);
    socket.emit("autofillform", token, response => {
      clearTimeout(timer);
      if (!response || typeof response !== "object" || !response.username || !response.password ||
          response.host !== "127.0.0.1" || Number(response.queryport) !== 10011 || response.protocol !== "raw") {
        reject(new Error("登录会话无效，请重新登录"));
      } else {
        resolve(response);
      }
    });
  });
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), 20000);
  try {
    const response = await fetch("/ts-api/admin/keys", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      redirect: "error",
      cache: "no-store",
      signal: controller.signal,
      body: JSON.stringify({ username: credentials.username, password: credentials.password, group_name: groupName, count, server_id: Number(serverId) }),
    });
    const body = await response.json().catch(() => ({}));
    if (!response.ok) {
      const messages = {
        401: "管理员验证失败，请重新登录",
        403: "请求被拒绝",
        404: "服务器身份组不存在，请刷新后重试",
        409: "身份组名称重复，请先调整名称",
        422: "请求参数无效，请确认虚拟服务器和数量",
        429: "请求过于频繁，请稍后重试",
        502: "创建失败，请先核对密钥列表与批次记录，勿直接重试",
        503: "TS 服务暂不可用，请先核对密钥列表后再试",
      };
      const error = new Error(messages[response.status] || "请求失败，请先核对密钥列表后再试");
      error.batchId = body.batch_id;
      throw error;
    }
    if (response.status !== 201 || body.count !== count || !Array.isArray(body.keys) ||
        body.keys.length !== count || body.keys.some(key => typeof key !== "string" || !key)) {
      throw new Error("接口返回异常，请先核对密钥列表，勿直接重试");
    }
    return body.keys;
  } catch (error) {
    if (error instanceof TypeError || error.name === "AbortError") {
      throw new Error("请求中断或超时，结果未确认；请先核对密钥列表，勿直接重试");
    }
    throw error;
  } finally {
    clearTimeout(timer);
  }
}
